export default __webpack_public_path__ + "static/assets/med_pill_triangle_out_L1_solid_x_01_f.7f669f83.png";